<p class="headline">{{ 'Ihre Anfrage wurde erfolgreich übermittelt!' |translate }}</p>

<button mat-flat-button class="send mat-primary" (click)="appService.resetApp()">{{ 'Neue Anfrage' |translate }}</button>

